export default class Application {
  constructor(rawData = {}) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.creationDate = rawData.creationDate;
    this.lastModificationDate = rawData.lastModificationDate;
    this.markedAsDeleted = rawData.markedAsDeleted;
  }
}